export default __webpack_public_path__ + "static/media/use6.2f2f263c.png";